import React from 'react';
import { useIntl } from 'react-intl';
import type { SongPublishFacts } from 'fym-shared/src/music24/songPublish';
import { TypedMemo } from '../../../common/types';
import { soundCloudUploadMessages as m } from '../soundCloudMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for SongUpload; each part uses its own slice of it */
import styles from './SongUpload.module.scss';
/* eslint-enable css-modules/no-unused-class */

const DASH = '—';

/** "What goes with it" (design c3): the master, the cover, the ISRC and the release, read only. */
const SongUploadFactsComponent: React.FC<{ facts: SongPublishFacts }> = ({ facts }) => {
  const intl = useIntl();
  const file = facts.master.state === 'ready' ? facts.master.fileName : DASH;
  const releaseDay =
    facts.releaseDate === null
      ? null
      : intl.formatDate(`${facts.releaseDate}T00:00:00`, {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
  const release = [facts.releaseTitle, releaseDay].filter((part) => part !== null && part !== '').join(' · ');
  return (
    <div className={styles.box}>
      <span className={styles.label}>{intl.formatMessage(m.withIt)}</span>
      <div className={styles.with}>
        {facts.coverUrl === null ? (
          <span className={styles.cover} />
        ) : (
          <img className={styles.cover} src={facts.coverUrl} alt="" />
        )}
        <dl className={styles.facts}>
          <dt>{intl.formatMessage(m.factAudio)}</dt>
          <dd>{intl.formatMessage(m.factAudioValue, { file })}</dd>
          <dt>{intl.formatMessage(m.factCover)}</dt>
          <dd>{facts.coverUrl === null ? DASH : intl.formatMessage(m.factCoverValue)}</dd>
          <dt>{intl.formatMessage(m.factIsrc)}</dt>
          <dd className={styles.mono}>{facts.isrc ?? DASH}</dd>
          <dt>{intl.formatMessage(m.factRelease)}</dt>
          <dd>{release === '' ? DASH : release}</dd>
        </dl>
      </div>
      <span className={styles.hint}>{withBrandWord(intl.formatMessage(m.factsHint))}</span>
    </div>
  );
};

export const SongUploadFacts = TypedMemo(SongUploadFactsComponent);
